import React from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import moment from 'moment'
import at from 'lodash/at'
import get from 'lodash/get'
import BigCalendar from 'react-big-calendar'
import PropTypes from 'prop-types'
import storage from 'local-storage-fallback'
import { Link } from 'react-router'
import { connect } from 'react-redux'

import { MonthEvent, DayEvent } from './event'
import DayHeader from './day-header'
import ToolbarContainer from '../../containers/calendar/toolbar-container'
import CalendarKey from './calendar-key'
import Unavailable from '../unavailable'

class Calendar extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      colors: {
        unassigned: 'red',
        scheduled: 'navy',
        inProgress: 'lime',
        pendingApproval: 'hotpink',
        archive: 'purple',
      },
    }

    this.handleChangeComplete = this.handleChangeComplete.bind(this)
    this.onSelectEvent = this.onSelectEvent.bind(this)
    this.onDoubleClickEvent = this.onDoubleClickEvent.bind(this)
    this.onSelectSlot  = this.onSelectSlot.bind(this)
    this.eventPropGetter = this.eventPropGetter.bind(this)
    this.onView = this.onView.bind(this)
    this.onNavigate = this.onNavigate.bind(this)
    this.componentDidMount = this.componentDidMount.bind(this)
  }

  componentDidMount () {
    const _this = this
    this.props.loadWorkOrdersForDate(this.props.currentDate)
    this.setState(
      { colors: { ...(this.state.colors), ...(JSON.parse(storage.getItem('calendarColors'))) } },
      () => storage.setItem('calendarColors', JSON.stringify(_this.state.colors))
    )
  }

  eventPropGetter({ status, technicians }) {
    const {
      unassigned,
      scheduled,
      inProgress,
      pendingApproval,
      archive,
    } = this.state.colors

    const color = {
      in_progress: inProgress,
      pending_approval: pendingApproval,
      signed_off: archive,
      open: technicians.length ? scheduled : unassigned
    }

    let style = this.props.currentView === 'day' ? { backgroundColor: get(color, status, 'yellow') } : {}
    return {
      style
    }
  }

  handleChangeComplete (status) {
    const _this = this
    return function(color) {
      _this.setState(
        {
          colors: {
            ...(_this.state.colors),
            [status]: color.hex
          }
        },
        () => {
          _this.forceUpdate()
          storage.setItem('calendarColors', JSON.stringify(_this.state.colors))
        }
      )
    }
  }

  onNavigate(targetDate) {
    this.props.loadWorkOrdersForDate(targetDate)
  }

  onView(currentView) {
    this.props.setCurrentView(currentView)
  }

  onSelectEvent ({ id }) {
    // show workOrderDetailsPopUp
  }

  onDoubleClickEvent({ id, status }) {
    if (status === 'pending_approval' || status === 'signed_off') {
      this.props.goToSummaryWorkOrder(id)
    } else {
      this.props.goToWorkOrder(id)
    }
  }

  onSelectSlot ({action, start, end, ...rest}) {
    if (action === 'select' && this.props.currentView == 'day') {
      this.props.createWorkOrderOnSlot(start, end)
    }
  }

  render () {
    const disabledFields = this.props.userType === 'Supervisor'
    if (disabledFields) {
      return (<Unavailable />)
    }

    BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment))

    let {
      workOrders,
      children,
      currentDate,
      currentView,
    } = this.props

    let events = workOrders.map(({
      id,
      location,
      technicians,
      starts_at,
      ends_at,
      status,
    }) => {
      const start = moment(starts_at), end = moment(ends_at)
      return {
        id,
        start: start.toDate(),
        end: end.toDate(),
        location,
        status,
        technicians,
      }
    })

    const viewTypes = ['month', 'day']
    const calendarKeys = ['unassigned', 'scheduled', 'inProgress', 'pendingApproval', 'archive']

    return (
      <div className="maats-calendar">
        <div style={{ width: '100%', height: '100%' }}>
          <BigCalendar
            view={currentView}
            events={events}
            views={viewTypes}
            step={30}
            showMultiDayTimes
            popup
            popupOffset={{ x: 30, y: 0 }}
            defaultDate={currentDate}
            onSelectEvent={this.onSelectEvent}
            onDoubleClickEvent={this.onDoubleClickEvent}
            selectable
            onView={this.onView}
            eventPropGetter={this.eventPropGetter}
            onSelectSlot={this.onSelectSlot}
            onNavigate={this.onNavigate}
            components={{
              toolbar: ToolbarContainer,
              month: {
                event: MonthEvent,
                dateHeader: DayHeader,
              },
              day: {
                event: DayEvent,
              },
            }}
          />
          <Link to={{ pathname: '/calendar/create-work-order', query: { start: this.props.currentDate.toISOString() } }} className='action-button add'/>
        </div>

        <ul style={{
          display: 'flex',
          backgroundColor: 'white',
          listStyleType: 'none',
          position: 'fixed',
          bottom: '1%',
          width: '78%',
          textAlign: 'center',
        }}>
          {calendarKeys.map((key) => (
            <CalendarKey
              key={key}
              keyName={key}
              onChangeComplete={this.handleChangeComplete}
              color={this.state.colors[key]}
            />
          ))}

          <li style={{
            flex: '1',
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'center'
          }} key="unassigned_techs">
            <span style={{
              fontSize: '15px',
              paddingLeft: '5px',
              backgroundColor: 'rgba(255,0,0,0.2)',
              alignSelf: 'center'
            }}>Tech Discrepancy</span>
          </li>
        </ul>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  const userType = get(state.auth, 'session.type')

  return {
    userType
  }
}

export default connect(mapStateToProps)(Calendar)



// WEBPACK FOOTER //
// ./src/components/calendar/calendar.js